'use-strict';

module.exports = ['$scope', '$state', '$stateParams', 'ngDroUtilsNotify', 'ngDroUAA', '$transitions',
    function ($scope, $state, $stateParams, ngDroUtilsNotify, ngDroUAA, $transitions) {

        /*
         * Config
         */

        // parametri per la richiesta canDo
        var params = {
            resource: "TEMPLATE",
            privilege: $stateParams.id ? "UPDATE" : "CREATE"
        };


        /*
         * Init
         */
        $scope.template = {};       //

        var backupTemplate = {};    //

        $scope.jdroPerms = {};      // conterrà i permessi

        // Ottengo i permessi per le operazioni Update o Create   
        ngDroUAA.Profile.canDo(params.resource, params.privilege)
                .then(function (result) {
                    $scope.jdroPerms[params.privilege] = result.data;
                    if ($scope.jdroPerms[params.privilege] === true) {
                        $stateParams.id ? getTemplate($stateParams.id) : getTemplate();
                    }
                })
                .catch(function (err) {
                    ngDroUtilsNotify.unregisterListner();
                });


        // Setto un listener su transition start :
        //      se ho cambiato qualche campo e non ho salvato faccio uscire un modal di conferma.
        $scope.deregisterListener = $transitions.onStart({to: '*'}, catchStateTransition);
        ngDroUtilsNotify.setDeregisterListner( $scope.deregisterListener );

        /*
         * Methods
         */

        //
        function getTemplate(id) {
            if (id) {
                ngDroUAA.Template.findOne($stateParams.id).then(function (response) {
                    $scope.template = response.data;
                    angular.copy($scope.template, backupTemplate);
                }).catch(function (err) {
                    ngDroUtilsNotify.error(null, 'jdro_role.notify_error_get.role',null,err);
                });
            }
        }

        // per $transitions, cattura gestisce unsaved changes
        function catchStateTransition(transition) {
            if (!angular.equals($scope.template, backupTemplate)) {

                var options = {
                    form: $scope.templateForm,
                    next: transition.to().name,
                    name: $scope.template.code,
                    success: $scope.submit,
                    dismiss: $scope.redirect,
                    perms: $scope.hasPerms
                };

                ngDroUtilsNotify.confirmUnsavedChanges(options);

                return false; // equivale al vecchio event.preventDefault();
            }

        }

        // mi serve nel template per disabilitare i campi 
        $scope.hasPerms = function () {
            return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
        };

        // Validazione del campo unique code.
        $scope.validateCode = (function () {
            return {
                test: function (value) {
                    try {
                        for (var i = 0, len = $scope.templates.length; (value.length > 0 && i < len); ++i) {
                            if ($rootScope.templates[i].code.toUpperCase() === value.toUpperCase() && $rootScope.templates[i].id !== template.id) {
                                return false;
                            }
                        }
                        return true;
                    } catch (ex) {
                        return true;
                    }
                }
            };
        })();

        // submit form
        $scope.submit = function (isValid, next) {

            $scope.submitted = true;

            if (isValid) {
                /**
                 * Distinguo le operazioni a seconda che mi trovo in fase 
                 * di inserimento o di update dell'oggetto template.
                 */
                if (!$scope.template.id) {
                    ngDroUAA.Template.save($scope.template)
                            .then(function () {
                                ngDroUtilsNotify.insertSuccess($scope.template.code);
                                $scope.redirect(next);
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.insertError($scope.template.code,err);
                            })
                            .finally(function () {});
                } else {
                    ngDroUAA.Template.update($scope.template)
                            .then(function () {
                                ngDroUtilsNotify.updateSuccess($scope.template.code);
                                $scope.redirect(next);
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.updateError($scope.template.code,err);
                            })
                            .finally(function () {});
                }
            }
        };

        // 
        $scope.cancel = function () {
            $state.go('uaa-module-template-list');
        };

        // Redirect alla pagina della lista.
        $scope.redirect = function (next) {
            ngDroUtilsNotify.unregisterListner();
            next = next ? next : 'uaa-module-template-list';
            $state.go(next);
        };
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/template/templateDetail/templateDetailCtrl.js
// module id = 415
// module chunks = 0